import gql from "graphql-tag";

export const GET_PAYMENT_STATUS_COUNT = gql`
  query Query($presentation: MID) {
    getPaymentStatusCount(presentation: $presentation)
  }
`;